/** US MPG from liters per 100 km (1 US gal = 3.785411784 L, 1 mi = 1.609344 km). */
export function lPer100kmToMpgUS(lPer100km) {
  const x = parseFloat(lPer100km, 10);
  if (!Number.isFinite(x) || x <= 0) return null;
  return 235.214583 / x;
}

export function formatMpgUS(lPer100km, fractionDigits = 1) {
  const mpg = lPer100kmToMpgUS(lPer100km);
  return mpg != null ? mpg.toFixed(fractionDigits) : '—';
}
